import React, { useContext } from 'react';
import clsx from 'clsx';
import { Grid } from '@nextiva/next-ui-components';

import {
  LicensesContext,
  actionTypes,
} from 'containers/pages/BillingLicenses/licensesContext';

import { ShadowDom } from './ShadowDom';

const LicensesTableHeader = () => {
  const {
    licensesState: { licenseListIsLoading, sortField, sortDirection },
    dispatch,
  } = useContext(LicensesContext);

  const handleSort = (e) => {
    const { id } = e.currentTarget;

    if (id === 'name') {
      dispatch({
        type: actionTypes.SET_SORT,
        sortField: id,
        sortType: 'string',
      });
    } else {
      dispatch({
        type: actionTypes.SET_SORT,
        sortField: id,
        sortType: 'number',
      });
    }
  };

  return (
    <div
      className="m-table-header"
      data-testid="PlatformAdminUI-Licensing-LicensesTableHeader"
    >
      {licenseListIsLoading && <ShadowDom />}
      {!licenseListIsLoading && (
        <Grid container>
          <Grid item xs={5}>
            <div
              role="presentation"
              id="name"
              onClick={handleSort}
              data-testid="PlatformAdminUI-Licensing-LicensesTableHeader-NameSort"
              className="table-header-item"
            >
              <span
                className="Heading6 m-table-header__text"
                data-testid="PlatformAdminUI-Licensing-LicensesTableHeader-Name"
              >
                Name
              </span>
              <span
                className={clsx(
                  'm-table-header__text',
                  'sort_icon',
                  sortField === 'name' && `${sortDirection}_icon`,
                )}
                data-testid={`PlatformAdminUI-Licensing-LicensesTableHeader-Name-${sortDirection}-icon`}
              />
            </div>
          </Grid>
          <Grid item xs={2}>
            <div
              role="presentation"
              id="licenseCount"
              onClick={handleSort}
              className="m-table-header__cell-align table-header-item"
              data-testid="PlatformAdminUI-Licensing-LicensesTableHeader-PurchasedSort"
            >
              <span
                className="Heading6 m-table-header__text m-table-header__text--right"
                data-testid="PlatformAdminUI-Licensing-LicensesTableHeader-Purchased"
              >
                Purchased
              </span>
              <span
                className={clsx(
                  'm-table-header__text',
                  'sort_icon',
                  sortField === 'licenseCount' && `${sortDirection}_icon`,
                )}
                data-testid={`PlatformAdminUI-Licensing-LicensesTableHeader-Purchased-${sortDirection}-icon`}
              />
            </div>
          </Grid>
          <Grid item xs={2}>
            <div
              className="m-table-header__cell-align table-header-item"
              role="presentation"
              id="numberOfLicensesAssigned"
              onClick={handleSort}
              data-testid="PlatformAdminUI-Licensing-LicensesTableHeader-AssignedSort"
            >
              <span
                className={clsx('Heading6', 'm-table-header__text')}
                data-testid="PlatformAdminUI-Licensing-LicensesTableHeader-Assigned"
              >
                Assigned
              </span>
              <span
                className={clsx(
                  'm-table-header__text',
                  'sort_icon',
                  sortField === 'numberOfLicensesAssigned' &&
                    `${sortDirection}_icon`,
                )}
                data-testid={`PlatformAdminUI-Licensing-LicensesTableHeader-Assigned-${sortDirection}-icon`}
              />
            </div>
          </Grid>
          <Grid item xs={2}>
            <div
              className="m-table-header__cell-align table-header-item"
              role="presentation"
              id="numberOfLicensesAvailable"
              onClick={handleSort}
              data-testid="PlatformAdminUI-Licensing-LicensesTableHeader-AvailableSort"
            >
              <span
                className={clsx('Heading6', 'm-table-header__text')}
                data-testid="PlatformAdminUI-Licensing-LicensesTableHeader-Available"
              >
                Available
              </span>
              <span
                className={clsx(
                  'm-table-header__text',
                  'sort_icon',
                  sortField === 'numberOfLicensesAvailable' &&
                    `${sortDirection}_icon`,
                )}
                data-testid={`PlatformAdminUI-Licensing-LicensesTableHeader-Available-${sortDirection}-icon`}
              />
            </div>
          </Grid>
        </Grid>
      )}
    </div>
  );
};

export default LicensesTableHeader;
